import React, { useState } from "react";
import logo from "../../assets/img/logo.jpeg";
import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

/* ── all class names prefixed with "lp__" to avoid clashes ── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

  @keyframes lp__spin   { to { transform: rotate(360deg); } }
  @keyframes lp__floatA { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(-18px) scale(1.04); } }
  @keyframes lp__floatB { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(14px) scale(0.97); } }
  @keyframes lp__floatC { 0%,100% { transform: translate(0,0); }             50% { transform: translate(10px,-12px); } }
  @keyframes lp__fadeUp { from { opacity:0; transform:translateY(28px); } to { opacity:1; transform:translateY(0); } }
  @keyframes lp__pulse  { 0%,100% { box-shadow: 0 0 0 0 rgba(10,85,86,0.4); } 70% { box-shadow: 0 0 0 9px rgba(10,85,86,0); } }
  @keyframes lp__shimmer {
    0%   { background-position: -400px 0; }
    100% { background-position:  400px 0; }
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .lp__root {
    min-height: 100vh;
    display: flex;
    font-family: 'Inter', 'Segoe UI', sans-serif;
    background: #eef6f6;
    position: relative;
    overflow: hidden;
  }

  /* ── blobs ── */
  .lp__blob { position: fixed; border-radius: 50%; pointer-events: none; }
  .lp__blob--1 {
    width: 500px; height: 500px; top: -170px; left: -170px;
    background: radial-gradient(circle, rgba(10,85,86,0.20) 0%, transparent 68%);
    animation: lp__floatA 8s ease-in-out infinite;
  }
  .lp__blob--2 {
    width: 440px; height: 440px; bottom: -130px; right: -110px;
    background: radial-gradient(circle, rgba(20,184,166,0.17) 0%, transparent 68%);
    animation: lp__floatB 10s ease-in-out infinite;
  }
  .lp__blob--3 {
    width: 310px; height: 310px; top: 38%; left: 40%;
    background: radial-gradient(circle, rgba(10,85,86,0.10) 0%, transparent 70%);
    animation: lp__floatC 12s ease-in-out infinite;
  }
  .lp__blob--4 {
    width: 200px; height: 200px; top: 8%; right: 30%;
    background: radial-gradient(circle, rgba(255,209,102,0.20) 0%, transparent 70%);
    animation: lp__floatB 9s ease-in-out infinite;
  }

  /* subtle grid */
  .lp__grid {
    position: fixed; inset: 0; pointer-events: none;
    background-image:
      linear-gradient(rgba(10,85,86,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(10,85,86,0.04) 1px, transparent 1px);
    background-size: 52px 52px;
  }

  /* ── left panel ── */
  .lp__panel {
    flex: 1.15;
    display: flex; flex-direction: column;
    justify-content: center; align-items: flex-start;
    padding: 72px 60px; gap: 28px; position: relative; z-index: 1;
  }

  .lp__panel-badge {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(10,85,86,0.08);
    border: 1px solid rgba(10,85,86,0.22);
    border-radius: 50px; padding: 8px 18px;
    font-family: 'Sora', sans-serif;
    font-size: 11.5px; font-weight: 700; color: #0a5556;
    letter-spacing: 0.08em; text-transform: uppercase;
    animation: lp__fadeUp 0.6s ease both;
  }
  .lp__panel-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: #0a5556; animation: lp__pulse 2s infinite;
  }

  .lp__panel-heading {
    font-family: 'Sora', sans-serif;
    font-size: clamp(30px, 3.6vw, 50px);
    font-weight: 800; color: #062020;
    line-height: 1.18; letter-spacing: -0.04em; max-width: 420px;
    animation: lp__fadeUp 0.65s 0.1s ease both;
  }
  .lp__panel-accent {
    color: #0a5556; position: relative; display: inline-block;
  }
  .lp__panel-accent::after {
    content: '';
    position: absolute; bottom: 1px; left: 0;
    width: 100%; height: 3px;
    background: linear-gradient(90deg, #0a5556, #14b8a6);
    border-radius: 2px;
  }

  .lp__panel-sub {
    font-size: 15px; color: #3d6060; max-width: 340px;
    line-height: 1.78; animation: lp__fadeUp 0.65s 0.18s ease both;
  }

  .lp__features { display: flex; flex-direction: column; gap: 12px; animation: lp__fadeUp 0.65s 0.26s ease both; }
  .lp__feature {
    display: flex; align-items: center; gap: 14px;
    background: rgba(255,255,255,0.74); backdrop-filter: blur(14px);
    border: 1px solid rgba(10,85,86,0.13);
    border-radius: 16px; padding: 14px 20px;
    font-size: 14px; font-weight: 600; color: #132b2b;
    box-shadow: 0 2px 14px rgba(10,85,86,0.07);
    transition: transform 0.22s, box-shadow 0.22s;
    cursor: default;
  }
  .lp__feature:hover { transform: translateX(7px); box-shadow: 0 6px 26px rgba(10,85,86,0.14); }
  .lp__feature-icon {
    width: 38px; height: 38px; border-radius: 11px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center; font-size: 17px;
    background: linear-gradient(135deg, #0a5556 0%, #14b8a6 100%);
    box-shadow: 0 4px 14px rgba(10,85,86,0.30);
  }

  /* stats */
  .lp__stats { display: flex; gap: 28px; animation: lp__fadeUp 0.65s 0.34s ease both; }
  .lp__stat { display: flex; flex-direction: column; gap: 3px; }
  .lp__stat-val {
    font-family: 'Sora', sans-serif; font-size: 27px; font-weight: 800;
    color: #0a5556; line-height: 1; letter-spacing: -0.03em;
  }
  .lp__stat-label { font-size: 11.5px; color: #6b8a8a; font-weight: 500; }
  .lp__stat-sep { width: 1px; background: rgba(10,85,86,0.16); align-self: stretch; }

  /* ── right ── */
  .lp__right {
    flex: 1; display: flex; align-items: center;
    justify-content: center; padding: 40px 32px;
    position: relative; z-index: 1;
  }

  /* ── card ── */
  .lp__card {
    width: 100%; max-width: 454px;
    background: rgba(255,255,255,0.90); backdrop-filter: blur(30px);
    border-radius: 32px;
    border: 1px solid rgba(255,255,255,0.88);
    box-shadow:
      0 0 0 1px rgba(10,85,86,0.06),
      0 8px 32px rgba(10,85,86,0.08),
      0 32px 80px rgba(0,0,0,0.11),
      inset 0 1px 0 #fff;
    padding: 48px 44px 42px;
    animation: lp__fadeUp 0.75s 0.15s ease both;
    position: relative; overflow: hidden;
  }
  .lp__card::before {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, #0a5556 0%, #14b8a6 55%, #FFD166 100%);
    border-radius: 32px 32px 0 0;
  }

  /* logo */
  .lp__logo-wrap { display: flex; justify-content: center; margin-bottom: 26px; }
  .lp__logo-ring {
    padding: 4px; border-radius: 24px;
    background: linear-gradient(135deg, #0a5556, #14b8a6);
    box-shadow: 0 8px 30px rgba(10,85,86,0.32);
  }
  .lp__logo-img {
    width: 100%; height: 62px; display: block;
    border-radius: 20px; object-fit: cover;
    border: 3px solid #fff;
  }

  .lp__card-title {
    font-family: 'Sora', sans-serif;
    font-size: 25px; font-weight: 800;
    color: #062020; text-align: center;
    margin-bottom: 7px; letter-spacing: -0.03em;
  }
  .lp__card-sub {
    font-size: 13.5px; color: #6b8a8a;
    text-align: center; margin-bottom: 30px; line-height: 1.62;
  }

  /* label */
  .lp__lbl {
    display: flex; align-items: center; gap: 6px;
    font-size: 11.5px; font-weight: 700; color: #132b2b;
    margin-bottom: 8px; letter-spacing: 0.06em; text-transform: uppercase;
  }
  .lp__lbl-dot { width: 5px; height: 5px; border-radius: 50%; background: #0a5556; }

  /* inputs */
  .lp__field { position: relative; margin-bottom: 18px; }
  .lp__input {
    width: 100%; padding: 14px 18px;
    font-size: 14.5px; font-family: 'Inter', sans-serif;
    color: #0a2020; background: #f3fafa;
    border: 1.5px solid #c8e4e4; border-radius: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }
  .lp__input:focus {
    border-color: #0a5556; background: #fff;
    box-shadow: 0 0 0 4px rgba(10,85,86,0.11);
  }
  .lp__input::placeholder { color: #9ababa; }
  .lp__input--pw { padding-right: 50px; }

  .lp__eye {
    position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
    background: none; border: none; cursor: pointer;
    color: #9ababa; font-size: 16px; padding: 4px;
    transition: color 0.2s;
  }
  .lp__eye:hover { color: #0a5556; }

  /* row */
  .lp__row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 22px; }
  .lp__remember { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 500; color: #2d4a4a; cursor: pointer; }
  .lp__chk { accent-color: #0a5556; width: 15px; height: 15px; cursor: pointer; }
  .lp__forgot { font-size: 13px; font-weight: 700; color: #0a5556; text-decoration: none; transition: opacity 0.2s; }
  .lp__forgot:hover { opacity: 0.68; }

  /* button */
  .lp__btn {
    width: 100%; padding: 15px;
    font-size: 15px; font-family: 'Sora', sans-serif; font-weight: 700;
    color: #fff; letter-spacing: 0.04em;
    background: linear-gradient(135deg, #0a5556 0%, #0c7172 50%, #14b8a6 100%);
    background-size: 200% auto;
    border: none; border-radius: 14px; cursor: pointer;
    box-shadow: 0 6px 26px rgba(10,85,86,0.38);
    transition: background-position 0.4s, transform 0.15s, box-shadow 0.2s;
    position: relative; overflow: hidden;
  }
  .lp__btn::after {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.14), transparent);
    background-size: 400px 100%; opacity: 0; transition: opacity 0.3s;
  }
  .lp__btn:hover { background-position: right center; transform: translateY(-2px); box-shadow: 0 12px 34px rgba(10,85,86,0.44); }
  .lp__btn:hover::after { opacity: 1; animation: lp__shimmer 1.1s linear infinite; }
  .lp__btn:active { transform: translateY(0); }
  .lp__btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none !important; }

  /* spinner */
  .lp__spin-icon {
    display: inline-block; width: 15px; height: 15px;
    border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
    border-radius: 50%; animation: lp__spin 0.72s linear infinite;
    vertical-align: middle; margin-right: 9px;
  }

  /* divider */
  .lp__div { display: flex; align-items: center; gap: 14px; margin: 22px 0; }
  .lp__div-line { flex: 1; height: 1px; background: #c8e4e4; }
  .lp__div-txt { font-size: 10.5px; font-weight: 700; color: #9ababa; letter-spacing: 0.12em; }

  /* socials */
  .lp__soc-row { display: flex; justify-content: center; gap: 14px; margin-bottom: 22px; }
  .lp__soc-btn {
    width: 52px; height: 52px; border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
    font-size: 20px; border: 1.5px solid #c8e4e4;
    background: #fff; cursor: pointer; color: #6b8a8a;
    transition: all 0.22s; box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  }
  .lp__soc-btn:hover { transform: translateY(-3px); }
  .lp__soc-btn--fb:hover { color: #1877f2; border-color: #1877f2; box-shadow: 0 8px 24px rgba(24,119,242,0.20); }
  .lp__soc-btn--gg:hover { color: #ea4335; border-color: #ea4335; box-shadow: 0 8px 24px rgba(234,67,53,0.20); }
  .lp__soc-btn--gh:hover { color: #24292e; border-color: #24292e; box-shadow: 0 8px 24px rgba(36,41,46,0.16); }

  /* footer */
  .lp__terms-link {
    display: block; text-align: center;
    font-size: 12px; color: #9ababa;
    margin-bottom: 12px; text-decoration: underline; cursor: pointer;
  }
  .lp__terms-link:hover { color: #0a5556; }
  .lp__footer { text-align: center; font-size: 13.5px; color: #6b8a8a; }
  .lp__reg-link { font-weight: 700; color: #0a5556; text-decoration: none; }
  .lp__reg-link:hover { text-decoration: underline; }

  /* responsive */
  @media (max-width: 860px) {
    .lp__panel { display: none !important; }
    .lp__right { padding: 28px 16px; }
    .lp__card { padding: 36px 28px 32px; border-radius: 24px; }
  }
`;

function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);

  /* ── unchanged backend logic ── */
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      Swal.fire("Error", "Email and Password are required", "error");
      return;
    }
    const payload = { email, password };
    console.log("Login payload:", payload);
    try {
      setLoading(true);
      const res = await axios.post(`${baseurl}loginUser`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("Login response:", res.data);
      if (res.data.success) {
        if (res.data.token) localStorage.setItem("auth_token", res.data.token);
        Swal.fire({ icon: "success", title: "Login successful", timer: 1500, showConfirmButton: false });
        setTimeout(() => { window.location.href = "/invoices"; }, 1200);
      } else {
        Swal.fire("Login Failed", res.data.message || "Invalid credentials", "error");
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{CSS}</style>

      <div className="lp__root">
        {/* blobs + grid */}
        <div className="lp__blob lp__blob--1" />
        <div className="lp__blob lp__blob--2" />
        <div className="lp__blob lp__blob--3" />
        <div className="lp__blob lp__blob--4" />
        <div className="lp__grid" />

        {/* ══ LEFT PANEL ══ */}
        <div className="lp__panel">
          <div className="lp__panel-badge">
            <div className="lp__panel-dot" />
            Certified & Secure
          </div>

          <h1 className="lp__panel-heading">
            Your complete<br />accounting &amp;<br />
            <span className="lp__panel-accent">billing solution</span>
          </h1>

          <p className="lp__panel-sub">
            Manage invoices, track expenses, reconcile accounts,
            and generate financial reports — all from one powerful platform.
          </p>

          <div className="lp__features">
            {[
              { icon: "🧾", text: "Automated invoicing & billing" },
              { icon: "📒", text: "GST / tax-compliant ledgers" },
              // { icon: "💳", text: "Multi-currency payment tracking" },
              { icon: "📈", text: "Profit & loss reports instantly" },
            ].map((f) => (
              <div className="lp__feature" key={f.text}>
                <div className="lp__feature-icon">{f.icon}</div>
                {f.text}
              </div>
            ))}
          </div>

          <div className="lp__stats">
            <div className="lp__stat">
              <span className="lp__stat-val">10k+</span>
              <span className="lp__stat-label">Businesses</span>
            </div>
            <div className="lp__stat-sep" />
            <div className="lp__stat">
              <span className="lp__stat-val">₹500Cr+</span>
              <span className="lp__stat-label">Invoices processed</span>
            </div>
            <div className="lp__stat-sep" />
            <div className="lp__stat">
              <span className="lp__stat-val">4.8★</span>
              <span className="lp__stat-label">User rating</span>
            </div>
          </div>
        </div>

        {/* ══ RIGHT CARD ══ */}
        <div className="lp__right">
          <div className="lp__card">

            <div className="lp__logo-wrap">
              <div className="lp__logo-ring">
                <img src={logo} alt="logo" className="lp__logo-img" />
              </div>
            </div>

            <h2 className="lp__card-title">Sign in to your account</h2>
            <p className="lp__card-sub">Access your books, invoices, and financial reports securely.</p>

            <form onSubmit={handleLogin} autoComplete="off">

              <div className="lp__lbl"><div className="lp__lbl-dot" />Registered Email</div>
              <div className="lp__field">
                <input
                  type="email"
                  className="lp__input"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="lp__lbl"><div className="lp__lbl-dot" />Password</div>
              <div className="lp__field">
                <input
                  type={showPassword ? "text" : "password"}
                  className="lp__input lp__input--pw"
                  placeholder="••••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="lp__eye"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  <i className={showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"} />
                </button>
              </div>

              <div className="lp__row">
                <label className="lp__remember">
                  <input type="checkbox" className="lp__chk" />
                  Keep me signed in
                </label>
                <a href="#" className="lp__forgot">Forgot password?</a>
              </div>

              <button type="submit" className="lp__btn" disabled={loading}>
                {loading
                  ? <><span className="lp__spin-icon" />Signing in…</>
                  : "Sign In →"
                }
              </button>
            </form>

            <div className="lp__div">
              <div className="lp__div-line" />
              <span className="lp__div-txt">OR SIGN IN WITH</span>
              <div className="lp__div-line" />
            </div>

            <div className="lp__soc-row">
              <div className="lp__soc-btn lp__soc-btn--fb"><i className="bi bi-facebook" /></div>
              <div className="lp__soc-btn lp__soc-btn--gg"><i className="bi bi-google" /></div>
              <div className="lp__soc-btn lp__soc-btn--gh"><i className="bi bi-github" /></div>
            </div>

            <a href="#" className="lp__terms-link">Terms of Service &amp; Privacy Policy</a>

            <p className="lp__footer">
              New to the platform?{" "}
              <Link to="/register" className="lp__reg-link">Create an account</Link>
            </p>
          </div>
        </div>

      </div>
    </>
  );
}

export default LoginPage;
